import SubscriptionCard from '@/components/SubscriptionCard';
import { SubscriptionStatus } from '@/constants/constants';
import { usePaywall } from '@/hooks/usePaywall';
import { setPageTitle } from '@/lib/appInsights';
import { PaywallContextType } from '@/types/util.types';
import { RxCardStack } from 'react-icons/rx';
import Section from '@/components/elements/Section';

function Purchases() {
  setPageTitle('Subscriptions');
  const { subscriptions } = usePaywall() as PaywallContextType;
  const activeSubscriptions = subscriptions.filter(
    (subscription) => subscription.status !== SubscriptionStatus.Expired
  );

  return (
    <Section title='Subscriptions' description='View and manage your subscriptions' background='white'>
      <div className='mt-6'>
        {activeSubscriptions.length > 0 ? (
          <div data-cy='subscriptions' className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6'>
            {activeSubscriptions.map((subscription) => (
              <SubscriptionCard key={subscription.id} subscription={subscription} />
            ))}
          </div>
        ) : (
          <div
            data-cy='no-active-subscriptions'
            className='flex gap-2 flex-col justify-center items-center border border-gray-200 p-8 rounded-lg'
          >
            <div className='flex justify-center items-center rounded-full bg-gray-200 w-12 h-12 mb-2'>
              <RxCardStack size={24} />
            </div>
            <p className='text-lg font-bold'>No active subscriptions</p>
            <p className='text-muted text-center'>You haven&apos;t subscribed to any authors yet.</p>
          </div>
        )}
      </div>
    </Section>
  );
}

export default Purchases;
